<template>
  <div class="wms-main">
    <div class="clock">
      <div class="hour-num">12</div>
      <div class="hour-num" style="transform: rotate(30deg)">1</div>
      <div class="hour-num" style="transform: rotate(60deg)">2</div>
      <div class="hour-num" style="transform: rotate(90deg)">3</div>
      <div class="hour-num" style="transform: rotate(120deg)">4</div>
      <div class="hour-num" style="transform: rotate(150deg)">5</div>
      <div class="hour-num" style="transform: rotate(180deg)">6</div>
      <div class="hour-num" style="transform: rotate(-150deg)">7</div>
      <div class="hour-num" style="transform: rotate(-120deg)">8</div>
      <div class="hour-num" style="transform: rotate(-90deg)">9</div>
      <div class="hour-num" style="transform: rotate(-60deg)">10</div>
      <div class="hour-num" style="transform: rotate(-30deg)">11</div>

      <div class="hour" :style="{ transform: `rotate(${hrsRotate}deg` }">
        <div class="hour-hand"></div>
      </div>
      <div class="min" :style="{ transform: `rotate(${minRotate}deg` }">
        <div class="min-hand"></div>
      </div>
      <div class="sec" :style="{ transform: `rotate(${secRotate}deg` }">
        <div class="sec-hand"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    secRotate: { type: Number, default: 0 },
    minRotate: { type: Number, default: 0 },
    hrsRotate: { type: Number, default: 0 },
  },
  methods: {
  },
  mounted() {
    var nowSecs = new Date().getSeconds();
    var nowMins = new Date().getMinutes();
    var nowHour = new Date().getHours();

    this.secRotate = nowSecs / 60 * 360;
    this.minRotate = nowMins / 60 * 360;
    this.hrsRotate = nowHour / 12 * 360;
    this.hrsRotate += this.minRotate / 360  * 30;

    var repeat = nowMins % 2 == 0 ? 0 : 1;
    setInterval(() => {
      this.secRotate += 6;
      if (this.secRotate % 360 == 0) {
        // this.secRotate = 0;
        this.minRotate += 6;
        repeat++;
        
        if (repeat == 2) {
          repeat = 0;
          this.hrsRotate += 1;
        }
      }
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
$background: rgb(119, 101, 0);
$hour-color: rgb(160, 136, 0);
$min-color: rgb(200, 170, 0);
$sec-color: rgb(255, 217, 0);

.wms-main {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clock {
  position: relative;
  height: 300px;
  width: 300px;
  background-color: $background;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid black;
}

.hour, .min, .sec {
  position: absolute;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  transition: 0.5s;
}

.hour {
  height: 10%;
  width: 10%;
  background-color: $hour-color;
}

.hour-hand {
  position: absolute;
  height: 70px;
  width: 7px;
  background-color: $hour-color;
  bottom: 100%;
}

.min {
  height: 8%;
  width: 8%;
  background-color: $min-color;
}

.min-hand {
  position: absolute;
  height: 100px;
  width: 5px;
  background-color: $min-color;
  bottom: 100%;
}

.sec {
  height: 6%;
  width: 6%;
  background-color: $sec-color;
}

.sec-hand {
  position: absolute;
  height: 130px;
  width: 3px;
  background-color: $sec-color;
  bottom: 100%;
}

.hour-num {
  position: absolute;
  height: 100%;
  color: white;
  font-weight: bold;
  font-size: 1.5em;
}
</style>